import React from "react";
import { motion } from "framer-motion";
import { Camera, Heart, Users, Sparkles } from "lucide-react";

const EventHeader = ({ photoCount = 0 }) => {
  return (
    <motion.div
      className="bg-gradient-to-br from-white via-neutral-ivory to-accent-rose/30 text-primary rounded-card p-6 sm:p-8 md:p-10 mb-6 sm:mb-8 shadow-elegant mx-2 sm:mx-0 border-2 border-accent-gold/30 backdrop-blur-xl relative overflow-hidden"
      initial={{ opacity: 0, y: -30, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ duration: 0.8, ease: "easeOut" }}
      whileHover={{
        scale: 1.01,
        boxShadow: "0 8px 30px rgba(212, 121, 107, 0.25)",
      }}
    >
      {/* Decoración de fondo */}
      <div className="absolute top-0 right-0 w-40 h-40 bg-accent-gold/10 rounded-full blur-3xl"></div>
      <div className="absolute bottom-0 left-0 w-32 h-32 bg-primary/5 rounded-full blur-2xl"></div>

      <div className="relative z-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
        <div className="flex items-center gap-4 sm:gap-5 w-full sm:w-auto">
          <motion.div
            className="p-4 sm:p-5 bg-gradient-to-br from-primary to-primary-light rounded-elegant backdrop-blur-sm flex-shrink-0 shadow-elegant border border-accent-gold/20"
            whileHover={{ scale: 1.1, rotate: 5 }}
            style={{ minWidth: "60px", minHeight: "60px" }}
          >
            <Camera className="w-7 h-7 sm:w-9 sm:h-9 mx-auto text-white drop-shadow-lg" />
          </motion.div>
          <div className="flex-1">
            <h1
              className="font-bold leading-tight drop-shadow-sm"
              style={{
                fontSize: "clamp(28px, 5vw, 40px)",
                fontFamily:
                  "'Dancing Script', 'Great Vibes', 'Allura', cursive",
                fontWeight: "700",
                color: "#e063d3ff",
                letterSpacing: "0.02em",
                fontStyle: "italic",
              }}
            >
              Nayeli & Enrique
            </h1>
            <div className="flex items-center gap-2 mt-1">
              <Sparkles className="w-4 h-4 text-accent-gold" />
              <p className="font-sans text-neutral-warm text-sm sm:text-base">
                ¡Comparte tus momentos inolvidables!
              </p>
            </div>
          </div>
        </div>

        {/* Contador de fotos elegante */}
        <motion.div
          className="flex items-center justify-center sm:justify-start gap-3 px-5 sm:px-6 py-3 sm:py-3 bg-gradient-to-br from-accent-rose to-white rounded-elegant w-full sm:w-auto border-2 border-secondary/20 shadow-soft"
          initial={{ scale: 0, opacity: 0 }}
          animate={{ scale: 1, opacity: 1 }}
          transition={{ delay: 0.3, type: "spring", stiffness: 300 }}
          whileHover={{ scale: 1.05 }}
        >
          <Heart
            className="w-5 h-5 sm:w-6 sm:h-6 text-secondary animate-pulse"
            fill="currentColor"
          />
          <span className="font-sans font-semibold text-base sm:text-lg text-primary drop-shadow-sm">
            {photoCount}{" "}
            {photoCount === 1 ? "foto compartida" : "fotos compartidas"}
          </span>
        </motion.div>
      </div>

      {/* Línea decorativa inferior */}
      <motion.div
        className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-transparent via-accent-gold to-transparent"
        initial={{ scaleX: 0 }}
        animate={{ scaleX: 1 }}
        transition={{ delay: 0.5, duration: 0.8 }}
      ></motion.div>
    </motion.div>
  );
};

export default EventHeader;
